// extracted by mini-css-extract-plugin
export var statItem = "_di-1";
export var statsRow = "_di-0";